export default "__VITE_ASSET__aaf9d9a3__"